import React from 'react';

interface InfoCardProps {
    icon: React.ComponentType<{ colour: string }>;
    text: string;
    marginRight?: boolean;
}

export const InfoCard = ({ icon: Icon, text, marginRight }: InfoCardProps) => (
    <div
        className={`flex-1 py-4 px-6 flex flex-col items-center bg-peppermint-500 rounded-t-lg rounded-bl-lg ${
            marginRight ? 'mr-2' : ''
        }`}
    >
        <Icon colour='#5B8C67' />
        <span className='text-sm'>{text}</span>
    </div>
);
